// 图片资源导入
import ninehImg from "@/assets/images/900.jpg";
import yaImg from "@/assets/images/ya.png";
import ninehxImg from "@/assets/images/900X.png";
import hhImg from "@/assets/images/hh.png";
import tgImg from "@/assets/images/tg.png";
import qxImg from "@/assets/images/qx.png";
import ymImg from "@/assets/images/ym.png";
import yyImg from "@/assets/images/yy.png";
import sdImg from "@/assets/images/sd.png";
import fcImg from "@/assets/images/fc.png";
import huayiImg from "@/assets/images/huayi.png";
import inviteImg2 from "@/assets/images/invite.jpg";
import hhinviteImg from "@/assets/images/hhinvite.jpg";
import qcjdyImg from "@/assets/images/qcjdy.png";
import hftyImg from "@/assets/images/hfty.png";
import bjmImg from "@/assets/images/bjm.jpg";
import htImg from "@/assets/images/ht.jpg";
import ddImg from "@/assets/images/dd.png";
import ddcxImg from "@/assets/images/ddcx.jpg";
import ltImg from "@/assets/images/lt.jpg";
import ydrdImg from "@/assets/images/ydrd.jpg";
import ydyxImg from "@/assets/images/ydyx.jpg";
import oyrxImg from "@/assets/images/oyrx.jpg";
import taImg from "@/assets/images/ta.jpg";
import phImg from "@/assets/images/ph.png";
import xpsxImg from "@/assets/images/xpsx.jpg";
import hpyxImg from "@/assets/images/hpyx.jpg";
import htycImg from "@/assets/images/htyc.jpg";
import qszxImg from "@/assets/images/qszx.jpg";
import ydzxImg from "@/assets/images/ydzx.png";
import yunyiImg from "@/assets/images/yunyi.jpg";
import yiqiImg from "@/assets/images/yiqi.jpg";
import lccxImg from "@/assets/images/lccx.jpg";

// 通用样式配置
export const DEFAULT_STYLE = {
  buttonBg: {
    backgroundImage: "linear-gradient(270deg, #3A8EEF 0%, #185CAA 100%)",
  },
  bannerTxt: {
    color: "#526799",
  },
  regainBtn: {
    color: "#185CAA",
  },
  mainColor: "#185CAA",
};

// 主机配置映射
export const HOST_CONFIG = {
  tgh5: { 
    img: tgImg, 
    title: "同港出行", 
    tel: "4001810622", 
    isYW: true,
    tenantOverrides: {
      tgyx: { title: "同港优行司机端" },
      lpyx: { title: "乐拼优行司机端" },
      mzyx: { title: "明智优行" }
    }
  },
  hhh5: { img: hhImg, title: "恒好用车", tel: "4006817887" },
  jbh5: { img: ninehImg, title: "900出行", tel: "4006555025" },
  qxh5: { img: qxImg, title: "前行约车", tel: "4001810622", isYW: true },
  qxych5: { 
    img: qxImg, 
    title: "前行约车", 
    tel: "4001810622", 
    isYW: true,
    tenantOverrides: {
      qxcx: { title: "前行出行", isYW: false }
    }
  },
  ymh5: { img: ymImg, title: "益民出行", tel: "4008893312" },
  yyh5: { img: yyImg, title: "易约出行", tel: "0311-85300111" },
  sdh5: { img: sdImg, title: "顺道好司机", tel: "400837986" },
  fch5: { img: fcImg, title: "风驰出行", tel: "0793-8213368" },
  fzxh5: { 
    img: ydzxImg, 
    title: "悦道用车智享版", 
    tel: "4001810622", 
    isYW: true,
    tenantOverrides: {
      ydzx: { img: ydzxImg, title: "悦道用车智享版" }
    }
  },
  jbxh5: { img: ninehxImg, title: "900行", tel: "4001810622", isJbx: true, isYW: true },
  yah5: { img: yaImg, title: "运昂出行", tel: "4006555025" },
  hyh5: { img: huayiImg, title: "华逸出行", tel: "4001660888" },
  qcjdy: { img: qcjdyImg, title: "七彩芳华行", tel: "4001660888" },
  hfty: { img: hftyImg, title: "合肥出租", tel: "4000005952" },
  bjm: { img: bjmImg, title: "八骏马出行司机端", tel: "4009938088" },
  "ht-h5": { img: htImg, title: "恒途出行", tel: "4009938088" },
  "dd-h5": { 
    img: ddImg, 
    title: "叮叮出行乐享版", 
    tel: "4001660888",
    tenantOverrides: {
      ddcx: { title: "叮叮出行", img: ddcxImg },
      ddyx: { title: "叮叮优行", img: ddcxImg },
    }
  },
  "lt-h5": { img: ltImg, title: "路团出行", tel: "4001660888" },
  "ydrd-h5": { 
    img: ydrdImg, 
    title: "悦道瑞达", 
    tel: "",
    tenantOverrides: {
      ydyc: { title: "悦道用车" }
    }
  },
  "ydyx-h5": { img: ydyxImg, title: "悦道悦行", tel: "" },
  "ydzd-h5": { img: ydyxImg, title: "悦道智达", tel: "" },
  "oyrx-h5": { img: oyrxImg, title: "鸥盈任行司机端", tel: "" },
  "ta-h5": { img: taImg, title: "途安约车", tel: "" },
  "ph-h5": { img: phImg, title: "鹏华同行", tel: "" },
  "xpsx-h5": { img: xpsxImg, title: "星鹏速行", tel: "" },
  "hpyx-h5": { img: hpyxImg, title: "海派约行司机端", tel: "" },
  "htyc-h5": { img: htycImg, title: "慧通约车", tel: "" },
  "qszx-h5": { img: qszxImg, title: "62580", tel: "" },
  "yunyi-h5": { img: yunyiImg, title: "荟宜出行", tel: "" },
  "yq-h5": { img: yiqiImg, title: "亿启出行", tel: "" },
  "lccx-h5": { img: lccxImg, title: "麒策出行", tel: "" }
};

// 租户配置映射
export const TENANT_CONFIG = {
  fangzhouxing: { name: "悦道用车智享版", invite: hhinviteImg },
  fzx: { name: "悦道用车智享版", invite: hhinviteImg },
  tonggang: { name: "同港出行极速版", invite: inviteImg2 },
  henghao: { name: "恒好用车司机", invite: hhinviteImg },
  nineh: { name: "900司机端极速版", invite: hhinviteImg },
  ninehx: { name: "900行司机端", invite: hhinviteImg },
  qianxing: { name: "前行约车", invite: hhinviteImg },
  qxyc: { name: "前行约车", invite: hhinviteImg },
  yiyue: { name: "易约司机极速版", invite: hhinviteImg },
  fengchi: { name: "风驰出行司机端极速版", invite: hhinviteImg },
  yimin: { name: "益民出行司机端极速版", invite: hhinviteImg },
  shundao: { name: "顺道出行司机端极速版", invite: hhinviteImg },
  ya: { name: "运昂司机端", invite: hhinviteImg },
  huayi: { name: "华逸出行司机端", invite: hhinviteImg },
  qcjdy: { name: "七彩芳华行", invite: hhinviteImg },
  hfty: { name: "合肥出租", invite: hhinviteImg },
  bjm: { name: "八骏马出行司机端", invite: hhinviteImg },
  ht: { name: "恒途出行", invite: hhinviteImg },
  dd: { name: "叮叮出行乐享版", invite: hhinviteImg },
  ddyx: { name: "叮叮优行", invite: hhinviteImg },
  lt: { name: "路团出行", invite: hhinviteImg },
  ydrd: { name: "悦道瑞达", invite: hhinviteImg },
  ydyx: { name: "悦道悦行", invite: hhinviteImg },
  ydyd: { name: "悦道约达", invite: hhinviteImg },
  ydzd: { name: "悦道智达", invite: hhinviteImg },
  oyrx: { name: "鸥盈任行司机端", invite: hhinviteImg },
  ta: { name: "途安约车", invite: hhinviteImg },
  ph: { name: "鹏华同行", invite: hhinviteImg },
  xpsx: { name: "星鹏速行", invite: hhinviteImg },
  hpyx: { name: "海派约行司机端", invite: hhinviteImg },
  htyc: { name: "慧通约车", invite: hhinviteImg },
  qszx: { name: "62580", invite: hhinviteImg },
  ydzx: { name: "悦道用车智享版", invite: hhinviteImg },
  yunyi: { name: "荟宜出行", invite: hhinviteImg },
  yiqi: { name: "亿启出行", invite: hhinviteImg },
  tgyx: { name: "同港优行司机端", invite: hhinviteImg },
  lpyx: { name: "乐拼优行司机端", invite: hhinviteImg },
  mzyx: { name: "明智优行", invite: hhinviteImg },
  lccx: { name: "麒策出行", invite: hhinviteImg }
};

// 特殊样式配置
export const SPECIAL_STYLES = {
  tonggang: {
    buttonBg: {
      backgroundImage: "linear-gradient(270deg, #FFA43C 0%, #F09533 100%)",
    },
    bannerTxt: { color: "#954A23" },
    regainBtn: { color: "#FFA43C" },
    mainColor: "#FFA43C",
  },
  qianxing: {
    ...DEFAULT_STYLE,
    buttonBg: {
      backgroundImage: "linear-gradient(270deg, #512e99 0%, #512e99 100%)",
    },
    regainBtn: { color: "#512e99" },
    mainColor: "#512e99",
  },
  qxyc: {
    ...DEFAULT_STYLE,
    buttonBg: {
      backgroundImage: "linear-gradient(270deg, #512e99 0%, #512e99 100%)",
    },
    regainBtn: { color: "#512e99" },
    mainColor: "#512e99",
  },
  fengchi: {
    ...DEFAULT_STYLE,
    buttonBg: {
      backgroundImage: "linear-gradient(270deg, #22d3c5 0%, #22d3c5 100%)",
    },
    regainBtn: { color: "#22d3c5" },
    mainColor: "#22d3c5",
  },
  shundao: {
    ...DEFAULT_STYLE,
    buttonBg: {
      backgroundImage: "linear-gradient(270deg, #f54a4a 0%, #f54a4a 100%)",
    },
    regainBtn: { color: "#f54a4a" },
    mainColor: "#f54a4a",
  },
  yiyue: {
    ...DEFAULT_STYLE,
    buttonBg: {
      backgroundImage: "linear-gradient(270deg, #265cf8 0%, #265cf8 100%)",
    },
    regainBtn: { color: "#265cf8" },
    mainColor: "#265cf8",
  },
  yimin: {
    ...DEFAULT_STYLE,
    buttonBg: {
      backgroundImage: "linear-gradient(270deg, #23afe6 0%, #23afe6 100%)",
    },
    regainBtn: { color: "#23afe6" },
    mainColor: "#23afe6",
  }
};

// 公司信息配置
export const COMPANY_CONFIG = {
  fangzhouxing: { 
    name: "上海美跃信息技术有限公司", 
    email: "shayixi@kongjiantiaoyue.com" 
  },
  fzx: { 
    name: "上海美跃信息技术有限公司", 
    email: "shayixi@kongjiantiaoyue.com" 
  },
  henghao: { 
    name: "杭州恒胜科技有限公司", 
    email: "82269008@qq.com" 
  },
  tonggang: { 
    name: "重庆渐臻科技有限公司", 
    email: "shayixi@kongjiantiaoyue.com" 
  },
  nineh: { 
    name: "上海久柏易游信息科技有限公司", 
    email: "shayixi@kongjiantiaoyue.com" 
  },
  ninehx: { 
    name: "上海久柏易游信息科技有限公司", 
    email: "shayixi@kongjiantiaoyue.com" 
  },
  qianxing: { 
    name: "前行无限(天津)科技有限公司", 
    email: "shayixi@kongjiantiaoyue.com" 
  },
  qxyc: { 
    name: "前行无限(天津)科技有限公司", 
    email: "shayixi@kongjiantiaoyue.com" 
  },
  fengchi: { 
    name: "上饶优驰科技有限公司", 
    email: "juqinghua@kongjiantiaoyue.com" 
  },
  shundao: { 
    name: "泉州市顺道网络科技有限公司", 
    email: "shayixi@kongjiantiaoyue.com" 
  },
  yiyue: { 
    name: "石家庄易约汽车服务有限公司", 
    email: "yiyuechuxing@163.com" 
  },
  yimin: { 
    name: "兰州益民出行汽车服务有限公司", 
    email: "shayixi@kongjiantiaoyue.com" 
  },
  ya: { 
    name: "上海久柏易游信息科技有限公司", 
    email: "shayixi@kongjiantiaoyue.com" 
  },
  huayi: { 
    name: "四川桔电科技有限公司", 
    email: "junhui.deng@baijuyiauto.com" 
  },
  qcjdy: { 
    name: "云南七彩筋斗云信息科技有限责任公司", 
    email: "shayixi@kongjiantiaoyue.com" 
  },
  hfty: { 
    name: "合肥天友汽车出租有限责任公司", 
    email: "shayixi@kongjiantiaoyue.com" 
  },
  bjm: { 
    name: "杭州八骏马网络科技有限公司", 
    email: "shayixi@kongjiantiaoyue.com" 
  },
  dd: { 
    name: "重庆庞大叮叮科技有限公司南京分公司", 
    email: "" 
  },
  ddyx: { 
    name: "重庆庞大叮叮科技有限公司南京分公司", 
    email: "" 
  },
  lt: { 
    name: "杭州熊轩汽车服务有限公司", 
    email: "" 
  },
  ydrd: { 
    name: "辽宁恒途创新科技有限公司", 
    email: "" 
  },
  ydyx: { 
    name: "辽宁恒途创新科技有限公司", 
    email: "" 
  },
  ydzd: { 
    name: "辽宁恒途创新科技有限公司", 
    email: "" 
  },
  ydyd: { 
    name: "上海美跃信息技术有限公司", 
    email: "" 
  },
  ta: { 
    name: "当前平台", 
    email: "" 
  },
  oyrx: { 
    name: "当前平台", 
    email: "" 
  },
  ph: { 
    name: "福州鹏华同行科技有限公司", 
    email: "" 
  },
  xpsx: { 
    name: "芜湖星鹏速行科技有限公司", 
    email: "" 
  },
  hpyx: { 
    name: "海派科技发展（海南）有限公司", 
    email: "" 
  },
  qszx: { 
    name: "强生致行有限公司", 
    email: "" 
  },
  ydzx: { 
    name: "上海美跃信息技术有限公司", 
    email: "" 
  },
  yiqi: { 
    name: "江西优于行科技有限公司", 
    email: "" 
  },
  lpyx: { 
    name: "哈尔滨市乐拼科技有限公司", 
    email: "" 
  },
  tgyx: { 
    name: "重庆渐臻科技有限公司", 
    email: "" 
  },
  mzyx: { 
    name: "峨眉山市利安汽车服务有限公司", 
    email: "" 
  },
  yunyi: { 
    name: "上海东达荟宜科技有限公司", 
    email: "" 
  },
  lccx: { 
    name: "徐州麒凯信息科技有限公司", 
    email: "" 
  }
};

// 应用下载配置
export const APP_DOWNLOAD_CONFIG = {
  android: {
    henghao: "https://app.mi.com/details?id=com.henghaochuxing.driver",
    tonggang: "https://a.app.qq.com/o/simple.jsp?pkgname=com.pokongchuxing.driver",
    nineh: "https://a.app.qq.com/o/simple.jsp?pkgname=com.jiubaichuxingpro.driver"
  },
  ios: {
    henghao: "https://itunes.apple.com/cn/app/id1564022371?mt=8",
    tonggang: "https://itunes.apple.com/cn/app/id1150334077?mt=8",
    nineh: "https://itunes.apple.com/cn/app/id1574928399?mt=8"
  }
};

// 流程名称映射
export const FLOW_MAP = {
  baidu: "百度地图",
  tengxun: "腾讯地图"
};
